import imageCompression from "browser-image-compression";

/**
 * Compress image to JPEG before upload
 * @param {File} file
 * @returns {File}
 */
export async function compressImageToJpeg(file) {
  const options = {
    maxSizeMB: 0.5,          // target size (500 KB)
    maxWidthOrHeight: 1200,  // resize
    useWebWorker: true,
    fileType: "image/jpeg", // FORCE JPEG
    initialQuality: 0.7,
  };

  const compressedFile = await imageCompression(file, options);

  return new File(
    [compressedFile],
    file.name.replace(/\.\w+$/, ".jpg"),
    { type: "image/jpeg" }
  );
}
